import { render, staticRenderFns } from "./PageUsers.vue?vue&type=template&id=2b4f3e26&scoped=true"
import script from "./PageUsers.vue?vue&type=script&lang=js"
export * from "./PageUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f3e26",
  null
  
)

export default component.exports